import { css } from '@emotion/core'
import { colors } from 'styles/variables'

export const list = css`
  list-style-type: circle;

  & > li {
    display: block;
    padding: 2px 0;
  }
`

export const toggle = css`
  cursor: pointer;

  text-decoration: underline;

  :hover {
    color: ${colors.black80};
  }
`
